import { render, staticRenderFns } from "./custom-flow-average-card.vue?vue&type=template&id=101f4966"
import script from "./custom-flow-average-card.vue?vue&type=script&lang=js"
export * from "./custom-flow-average-card.vue?vue&type=script&lang=js"
import style0 from "./custom-flow-average-card.vue?vue&type=style&index=0&id=101f4966&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports